import {
  Component,
  OnChanges,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  ChangeDetectionStrategy,
  TemplateRef,
} from '@angular/core';
import { ColorHelper } from '../common/color.helper';
import { escapeLabel } from '../common/label.helper';
import { DataItem, StringOrNumberOrDate } from '../models/chart-data.model';
import { StyleTypes } from '../common/tooltip/style.type';
import { PlacementTypes } from '../common/tooltip/position';
import { ViewDimensions } from '../common/types/view-dimension.interface';

interface TreeMapCell {
  data: DataItem;
  fill: string;
  height: number;
  label: string;
  value: any;
  width: number;
  x: number;
  y: number;
  formatedValue: string;
}

@Component({
  selector: 'g[ngx-charts-tree-map-cell-series]',
  template: `
    <svg:g
      ngx-charts-tree-map-cell
      *ngFor="let c of cells; trackBy: trackBy"
      [data]="c.data"
      [x]="c.x"
      [y]="c.y"
      [width]="c.width"
      [height]="c.height"
      [fill]="c.fill"
      [label]="c.label"
      [value]="c.value"
      [valueFormatting]="valueFormatting"
      [labelFormatting]="labelFormatting"
      [gradient]="gradient"
      [animations]="animations"
      (select)="onClick($event)"
      ngx-tooltip
      [tooltipDisabled]="tooltipDisabled"
      [tooltipPlacement]="placementTypes.Top"
      [tooltipType]="styleTypes.tooltip"
      [tooltipTitle]="tooltipTemplate ? undefined : getTooltipText(c)"
      [tooltipTemplate]="tooltipTemplate"
      [tooltipContext]="c.data"
    ></svg:g>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeMapCellSeriesComponent implements OnChanges {
  @Input() data: any; // type this
  @Input() dims: ViewDimensions;
  @Input() colors: ColorHelper;
  @Input() valueFormatting: any;
  @Input() labelFormatting: any;
  @Input() gradient: boolean = false;
  @Input() tooltipDisabled: boolean = false;
  @Input() tooltipTemplate: TemplateRef<any>;
  @Input() animations: boolean = true;

  @Output() select = new EventEmitter();

  cells: TreeMapCell[];
  styleTypes = StyleTypes;
  placementTypes = PlacementTypes;

  ngOnChanges(changes: SimpleChanges): void {
    this.cells = this.getCells();
  }

  getCells(): TreeMapCell[] {
    if(this.data.children) {
      return this.data.children
      .filter((d) => {
        return d.depth === 1;
      })
      .map((d, index) => {
        const label = d.data.label;

        let tmc = {
          data: d.data,
          x: d.x0,
          y: d.y0,
          width: d.x1 - d.x0,
          height: d.y1 - d.y0,
          fill: this.colors.getColor(d.id),
          label,
          value: d.value,
          formatedValue: this.getFormattedValue(d.data)
        };
        if (!!d.data['color']) { // injection des couleurs depuis une props du FD
          tmc.fill = d.data['color'];
        }
        return tmc;
      });
    }
    return [];
  }

  getTooltipText({ label, value, formatedValue }: { label: any; value: any; formatedValue: any; }): string {
    return `
      <span class="tooltip-label">${escapeLabel(label)}</span>
      <span class="tooltip-val">${formatedValue}</span>
    `;
  }

  onClick(data): void {
    this.select.emit(data);
  }

  trackBy(index, item): string {
    return item.label;
  }

  getFormattedValue(dataItem: DataItem): StringOrNumberOrDate {
    if (dataItem.extra) {
      return dataItem.extra;
    }
    return dataItem.value;
  }
}
